import { forwardRef } from 'react';
import { StyledField } from './styled';
import { useField } from '../../../hooks';
import { FieldProvider } from '../../../contexts/field';

const Field = forwardRef((props, ref) => {
  const { fieldProps, labelProps, inputProps } = useField();

  return (
    <FieldProvider
      value={{
        labelProps,
        inputProps,
      }}
    >
      <StyledField {...fieldProps(ref, props)} />
    </FieldProvider>
  );
});

export default Field;
